export class BaseVictoryPointData {
}
